import { render, staticRenderFns } from "./InternalIngredientsTree.vue?vue&type=template&id=d1bdb2c4&scoped=true&"
import script from "./InternalIngredientsTree.vue?vue&type=script&lang=js&"
export * from "./InternalIngredientsTree.vue?vue&type=script&lang=js&"
import style0 from "./InternalIngredientsTree.vue?vue&type=style&index=0&id=d1bdb2c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1bdb2c4",
  null
  
)

export default component.exports